// extracted by mini-css-extract-plugin
export default {"mCard":"hB-z","image":"iB-z","imageNoBackground":"jB-z","imageHasCategory":"kB-z","fullWidth":"lB-z"};